import type { EntityType, WorkflowApi } from './types'
import { workflowApiV2 } from './v2'
import { workflowApiV3 } from './v3'

/**
 * Moments live on the v2 workflow API. Blocks live on v3. Hooks call this
 * and never import a versioned client directly.
 */
export const workflowApiFor = (entityType: EntityType): WorkflowApi =>
  entityType === 'block' ? workflowApiV3 : workflowApiV2

export type * from './types'
